/* One main picture on phones. Only the roller photo-tool route loads this file. */
(function () {
  const FULLSCREEN_STATE = 'ndrPreviewFullscreen';

  function setupMeasureHelp(section) {
    const opener = section.querySelector('[data-measure-help-open]');
    const dialog = section.querySelector('[data-measure-help-dialog]');
    const closer = dialog?.querySelector('[data-measure-help-close]');
    const inside = dialog?.querySelector('[data-inside-measure-help]');
    const outside = dialog?.querySelector('[data-outside-measure-help]');
    const form = section.querySelector('[data-configurator-form]');
    if (!opener || !dialog || !closer || !inside || !outside || section.dataset.wvMeasureHelp) return;
    section.dataset.wvMeasureHelp = 'true';

    const isOutsideMount = () => {
      const selected = form?.querySelector('[name="mount_location"]:checked')?.value;
      if (selected) return selected === 'outside';
      if (form?.dataset.measurementMountLocation) return form.dataset.measurementMountLocation === 'outside';
      try {
        return JSON.parse(section.dataset.configuration || '{}').options?.mount_location === 'outside';
      } catch (_) {
        return false;
      }
    };
    const open = () => {
      const outsideMount = isOutsideMount();
      inside.hidden = outsideMount;
      outside.hidden = !outsideMount;
      dialog.setAttribute('aria-label', outsideMount ? 'How to measure an outside mount' : 'How to measure an inside mount');
      dialog.showModal();
    };
    opener.addEventListener('click', open);
    closer.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => opener.focus({preventScroll: true}));
  }

  function setupFullscreen(section, preview, place, space) {
    if (section.dataset.wvPreviewFullscreen || typeof document.createElement('dialog').showModal !== 'function') return;
    section.dataset.wvPreviewFullscreen = 'true';

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'wv-preview-fullscreen-open';
    trigger.setAttribute('data-preview-fullscreen-open', '');
    trigger.setAttribute('aria-label', 'Open picture full screen');
    trigger.innerHTML = '<span aria-hidden="true">⛶</span><span>Full screen</span>';
    preview.append(trigger);

    const dialog = document.createElement('dialog');
    dialog.className = 'wv-preview-fullscreen';
    dialog.setAttribute('data-preview-fullscreen-dialog', '');
    dialog.setAttribute('aria-label', 'Full-screen shade picture');
    dialog.innerHTML = '<button type="button" class="wv-preview-fullscreen__close" data-preview-fullscreen-close aria-label="Close full-screen picture"><span aria-hidden="true">×</span></button><div class="wv-preview-fullscreen__frame" data-preview-fullscreen-frame></div>';
    document.body.append(dialog);
    const close = dialog.querySelector('[data-preview-fullscreen-close]');
    const frame = dialog.querySelector('[data-preview-fullscreen-frame]');

    let returnMarker = null;
    let pushed = false;
    let stateToken = '';
    let oldBodyOverflow = '';

    const markSlider = () => preview.querySelector('.wv-drop-bar, .wv-slide')?.classList.add('wv-slide');
    new MutationObserver(markSlider).observe(preview, {childList: true});
    markSlider();

    const restore = () => {
      if (returnMarker?.parentNode) returnMarker.replaceWith(preview);
      returnMarker = null;
      place();
      space();
      document.body.style.overflow = oldBodyOverflow;
      document.body.classList.remove('wv-preview-fullscreen-open');
      pushed = false;
      trigger.focus({preventScroll: true});
    };
    const closeNow = () => {
      if (dialog.open) dialog.close();
    };
    const requestClose = () => {
      if (!dialog.open) return;
      if (pushed && history.state?.[FULLSCREEN_STATE] === stateToken) history.back();
      else closeNow();
    };
    const open = () => {
      if (dialog.open) return;
      markSlider();
      returnMarker = document.createComment('main picture full-screen return position');
      preview.before(returnMarker);
      frame.append(preview);
      oldBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      document.body.classList.add('wv-preview-fullscreen-open');
      try {
        dialog.showModal();
      } catch (_) {
        restore();
        return;
      }
      stateToken = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      try {
        history.pushState({...history.state, [FULLSCREEN_STATE]: stateToken}, '', globalThis.location.href);
        pushed = true;
      } catch (_) {
        pushed = false;
      }
      close.focus({preventScroll: true});
    };

    trigger.addEventListener('click', open);
    close.addEventListener('click', requestClose);
    dialog.addEventListener('cancel', event => {
      event.preventDefault();
      requestClose();
    });
    dialog.addEventListener('click', event => {
      if (event.target === dialog) requestClose();
    });
    dialog.addEventListener('close', restore);
    globalThis.addEventListener('popstate', () => {
      if (!dialog.open) return;
      pushed = false;
      closeNow();
    });
  }

  function boot() {
    document.querySelectorAll('[data-no-drill-configurator]').forEach(section => {
      setupMeasureHelp(section);
      const preview = section.querySelector('[data-product-preview]');
      const layout = section.querySelector('.ndr-configurator__layout');
      const form = section.querySelector('[data-configurator-form]');
      if (!preview || !layout || !form || section.dataset.wvSinglePicture) return;
      section.dataset.wvSinglePicture = 'true';
      const anchor = document.createComment('main picture desktop position');
      preview.before(anchor);
      const media = matchMedia('(max-width: 799px)');
      const note = document.createElement('p');
      note.className = 'wv-phone-picture-note';
      note.textContent = 'Picture guide. Color, light and fit may vary.';
      preview.append(note);
      let fullscreenOpen = false;
      const space = () => {
        const height = media.matches && !fullscreenOpen ? Math.ceil(preview.getBoundingClientRect().height + 16) : 0;
        layout.style.setProperty('--wv-picture-space', height + 'px');
      };
      const place = () => {
        fullscreenOpen = Boolean(document.querySelector('[data-preview-fullscreen-dialog][open]'));
        if (fullscreenOpen) return;
        if (media.matches) layout.insertBefore(preview, form);
        else anchor.after(preview);
        space();
      };
      media.addEventListener('change', place);
      if (typeof ResizeObserver === 'function') new ResizeObserver(space).observe(preview);
      setupFullscreen(section, preview, place, space);
      place();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true});
  else boot();
})();
